import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Inscricoes() {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    categoria: '',
    programa: '',
    mensagem: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const categories = [
    {
      id: 'desenvolvimento',
      name: 'Trilhas de Desenvolvimento',
      icon: 'ri-mind-map',
      programs: [
        { id: 'despertar', name: 'Programa Despertar', price: 'R$ 497,00' },
        { id: 'inteligencia-emocional', name: 'Inteligência Emocional', price: 'R$ 297,00' },
        { id: 'lideranca', name: 'Liderança e Comunicação', price: 'R$ 397,00' }
      ]
    },
    {
      id: 'profissional',
      name: 'Trilhas Profissionais',
      icon: 'ri-briefcase-line',
      programs: [
        { id: 'gestao-pessoas', name: 'Gestão de Pessoas', price: 'R$ 897,00' },
        { id: 'administracao', name: 'Administração', price: 'R$ 797,00' },
        { id: 'marketing-digital', name: 'Marketing Digital', price: 'R$ 697,00' },
        { id: 'tecnologia', name: 'Tecnologia da Informação', price: 'R$ 1.197,00' },
        { id: 'atendimento', name: 'Atendimento ao Cliente', price: 'R$ 497,00' },
        { id: 'vendas', name: 'Vendas e Negociação', price: 'R$ 597,00' }
      ]
    },
    {
      id: 'ead',
      name: 'Trilhas EAD',
      icon: 'ri-computer-line',
      programs: [
        { id: 'ead-basico', name: 'Pacote Básico EAD', price: 'R$ 197,00/mês' },
        { id: 'ead-completo', name: 'Pacote Completo EAD', price: 'R$ 297,00/mês' },
        { id: 'ead-premium', name: 'Pacote Premium EAD', price: 'R$ 497,00/mês' }
      ]
    },
    {
      id: 'especial',
      name: 'Programas Especiais',
      icon: 'ri-star-line',
      programs: [
        { id: 'geracao-valor', name: 'Geração Valor', price: 'R$ 697,00' },
        { id: 'mentoria-individual', name: 'Mentoria Individual', price: 'R$ 397,00/sessão' },
        { id: 'mentoria-grupo', name: 'Mentoria em Grupo', price: 'R$ 197,00/sessão' }
      ]
    }
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target as HTMLFormElement;
    const formDataToSend = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d4j5hbnb8l4gait66iig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', telefone: '', categoria: '', programa: '', mensagem: '' });
        setSelectedCategory('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 5000);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (name === 'categoria') {
      setSelectedCategory(value);
      setFormData({
        ...formData,
        categoria: value,
        programa: ''
      });
    }
  };

  const selectedCategoryData = categories.find(cat => cat.id === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Inscrições e Matrículas
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Escolha seu programa e comece sua jornada de transformação hoje mesmo
            </p>
          </div>
        </div>
      </section>

      {/* Programs Overview */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nossos Programas</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Escolha a categoria que melhor se adequa aos seus objetivos
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {categories.map((category) => (
              <div key={category.id} className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{category.name}</h3>
                <p className="text-slate-600 mb-4">{category.programs.length} opções disponíveis</p>
                <button
                  onClick={() => {
                    setSelectedCategory(category.id);
                    setFormData({ ...formData, categoria: category.id, programa: '' });
                    document.getElementById('form-section')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-blue-600 font-semibold hover:text-blue-700 flex items-center gap-2 cursor-pointer"
                >
                  Ver programas
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Payment Methods */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Formas de Pagamento</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Facilitamos o acesso à educação com diversas opções de pagamento
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-qr-code-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">PIX</h3>
              <p className="text-slate-700 mb-2">Pagamento instantâneo</p>
              <p className="text-sm text-green-600 font-semibold">5% de desconto</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-card-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Cartão de Crédito</h3>
              <p className="text-slate-700 mb-2">Parcelamento em até 12x</p>
              <p className="text-sm text-slate-600">Sem juros</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Boleto Bancário</h3>
              <p className="text-slate-700 mb-2">Parcelamento em até 6x</p>
              <p className="text-sm text-slate-600">Sem juros</p>
            </div>
          </div>
        </div>
      </section>

      {/* Enrollment Form */}
      <section id="form-section" className="py-20 bg-gradient-to-b from-slate-50 to-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl border border-slate-100">
              <div className="text-center mb-8">
                <h2 className="text-4xl font-bold text-slate-900 mb-4">Fazer Minha Matrícula</h2>
                <p className="text-lg text-slate-600">
                  Preencha o formulário e nossa equipe entrará em contato para finalizar sua inscrição
                </p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-6 py-4 rounded-xl mb-8 flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-3xl"></i>
                  <div>
                    <p className="font-bold">Inscrição enviada com sucesso!</p>
                    <p className="text-sm">Nossa equipe entrará em contato em breve para finalizar sua matrícula.</p>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-6 py-4 rounded-xl mb-8 flex items-center gap-3">
                  <i className="ri-error-warning-fill text-3xl"></i>
                  <div>
                    <p className="font-bold">Erro ao enviar inscrição</p>
                    <p className="text-sm">Por favor, tente novamente ou entre em contato conosco.</p>
                  </div>
                </div>
              )}

              <form id="inscricoes-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-semibold text-slate-900 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all"
                    placeholder="Seu nome completo"
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-2">
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all"
                      placeholder="seu@email.com"
                    />
                  </div>

                  <div>
                    <label htmlFor="telefone" className="block text-sm font-semibold text-slate-900 mb-2">
                      Telefone/WhatsApp *
                    </label>
                    <input
                      type="tel"
                      id="telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all"
                      placeholder="(11) 99999-9999"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="categoria" className="block text-sm font-semibold text-slate-900 mb-2">
                    Categoria de Interesse *
                  </label>
                  <select
                    id="categoria"
                    name="categoria"
                    value={formData.categoria}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 pr-8 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all appearance-none bg-white cursor-pointer"
                    style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23475569'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.75rem center', backgroundSize: '1.5em 1.5em' }}
                  >
                    <option value="">Selecione uma categoria</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                  </select>
                </div>

                {selectedCategoryData && (
                  <div>
                    <label htmlFor="programa" className="block text-sm font-semibold text-slate-900 mb-2">
                      Programa Específico *
                    </label>
                    <select
                      id="programa"
                      name="programa"
                      value={formData.programa}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 pr-8 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all appearance-none bg-white cursor-pointer"
                      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23475569'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.75rem center', backgroundSize: '1.5em 1.5em' }}
                    >
                      <option value="">Selecione um programa</option>
                      {selectedCategoryData.programs.map((program) => (
                        <option key={program.id} value={program.id}>
                          {program.name} - {program.price}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div>
                  <label htmlFor="mensagem" className="block text-sm font-semibold text-slate-900 mb-2">
                    Mensagem (opcional)
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all resize-none"
                    placeholder="Conte-nos mais sobre seus objetivos e expectativas..."
                  ></textarea>
                  <p className="text-sm text-slate-500 mt-2">
                    {formData.mensagem.length}/500 caracteres
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-5 rounded-full font-bold text-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin text-2xl"></i>
                      Enviando inscrição...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-send-plane-fill text-xl"></i>
                      Fazer Minha Matrícula
                    </span>
                  )}
                </button>

                <p className="text-center text-sm text-slate-600">
                  Ao enviar este formulário, você concorda em ser contatado por nossa equipe para finalizar sua inscrição.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Por Que Escolher o Instituto Allcance?</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-medal-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Certificação Reconhecida</h3>
              <p className="text-slate-700">Certificados válidos em todo território nacional</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Professores Especializados</h3>
              <p className="text-slate-700">Equipe com experiência de mercado e acadêmica</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-briefcase-line text-4xl text-slate-900"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Encaminhamento ao Mercado</h3>
              <p className="text-slate-700">85% dos alunos conseguem emprego após o curso</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-slate-900 mb-4">Perguntas Frequentes</h2>
            </div>
            <div className="space-y-4">
              <details className="bg-white p-6 rounded-xl shadow-lg border border-slate-100 cursor-pointer">
                <summary className="font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  Como funciona o processo de matrícula?
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </summary>
                <p className="text-slate-700 mt-4 leading-relaxed">
                  Após preencher o formulário, nossa equipe entrará em contato em até 24 horas para confirmar sua inscrição, esclarecer dúvidas e orientar sobre o pagamento e início das aulas.
                </p>
              </details>
              <details className="bg-white p-6 rounded-xl shadow-lg border border-slate-100 cursor-pointer">
                <summary className="font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  Posso parcelar o pagamento?
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </summary>
                <p className="text-slate-700 mt-4 leading-relaxed">
                  Sim! Oferecemos parcelamento em até 12x no cartão de crédito sem juros, ou até 6x no boleto bancário. Pagamentos via PIX têm 5% de desconto.
                </p>
              </details>
              <details className="bg-white p-6 rounded-xl shadow-lg border border-slate-100 cursor-pointer">
                <summary className="font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  Há bolsas de estudo disponíveis?
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </summary>
                <p className="text-slate-700 mt-4 leading-relaxed">
                  Sim! Oferecemos bolsas integrais e parciais para pessoas em situação de vulnerabilidade social. Entre em contato para saber mais sobre os critérios e disponibilidade.
                </p>
              </details>
              <details className="bg-white p-6 rounded-xl shadow-lg border border-slate-100 cursor-pointer">
                <summary className="font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  Quando começam as aulas?
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </summary>
                <p className="text-slate-700 mt-4 leading-relaxed">
                  Temos turmas iniciando mensalmente. Após a confirmação da matrícula, você será informado sobre a data de início da próxima turma disponível.
                </p>
              </details>
              <details className="bg-white p-6 rounded-xl shadow-lg border border-slate-100 cursor-pointer">
                <summary className="font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  O certificado é reconhecido?
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </summary>
                <p className="text-slate-700 mt-4 leading-relaxed">
                  Sim! Todos os nossos certificados são reconhecidos e válidos em todo território nacional, podendo ser utilizados em processos seletivos e para comprovação de horas complementares.
                </p>
              </details>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
